// import moment from 'moment';

import jwtDecode from 'jwt-decode';

import application from 'application/application';

application

	.factory('authentication', () => {

		return {
			isLogged() {

				var expires = localStorage.getItem('__expires_in__');
				var authenticationToken = localStorage.getItem('__authenticationToken__');

				if (expires && authenticationToken) {
					var dateNew = new Date();
					var dateExpires = new Date(expires);

					return dateExpires > dateNew;
				}

				return false;

			},
			signIn(data, callback) {

				localStorage.setItem('__authenticationToken__', data['access_token']);

				localStorage.setItem('__authenticationTokenType__', data['token_type']);

				localStorage.setItem('__authenticationRefreshToken__', data['refresh_token']);

				// localStorage.setItem('__authenticationExpires__', (new Date(data['.expires'])).toISOString());

				localStorage.setItem('__authenticationUserData__', JSON.stringify(jwtDecode(localStorage.getItem('__authenticationToken__'))));

				typeof callback === 'function' && callback();

			},
			getUserData(key) {

				var authenticationUserData = JSON.parse(localStorage.getItem('__authenticationUserData__'));

				return (authenticationUserData && authenticationUserData.hasOwnProperty(key)) ? authenticationUserData[key] : undefined;

			}
		};

	});
